import { gql } from '@apollo/client'

export const GET_MARKET_BY_ID_QUERY = gql`
  query getMarketById($id: ID!) {
    marketById: markets_by_id(id: $id) {
      code
      phone
      phone_caption
      sms
      email
      locations_email
      merchants_email
      facebook_link
      instagram_link
      linkedin_link
      opening_hours {
        days
        open
        close
        is_closed
      }
      special_opening_hours {
        date
        open
        close
        title
        is_closed
        translations {
          title
        }
      }
      legal_entity {
        name
        organization_number
        address
        postal_code
        city
      }
    }
  }
`
